<template>

    <div class="AttributionMain">
        <div class="attrTitle">Icon Authors</div>
        <div>
            Author: smart/icons<br>
            Icon: 2998142_cloud_forecast_rainbow_weather_icon <br>
            Link: <a href="https://www.iconfinder.com/atifarshad">https://www.iconfinder.com/atifarshad</a><br>
            License: <a href = "https://creativecommons.org/licenses/by-sa/3.0/">https://creativecommons.org/licenses/by-sa/3.0/</a><br>
        </div>
        <div>
            Author: Kalash<br>
            Icon: 5241490_alarmed_emoji_face_sad_saddened_icon<br>
            Link: <a href="https:https://www.iconfinder.com/Kalashnyk/collections">https:https://www.iconfinder.com/Kalashnyk/collections</a><br>
            License: <a href = "https://creativecommons.org/licenses/by-sa/3.0/">https://creativecommons.org/licenses/by-sa/3.0/</a><br>
        </div>
        <div>
            Author: Kalash <br>
            Icon: 5241496_emoji_face_positive_smile_smiley_icon<br>
            Link:<a href="https://www.iconfinder.com/Kalashnyk/collections">https://www.iconfinder.com/Kalashnyk/collections</a><br>
            License: <a href = "https://creativecommons.org/licenses/by-sa/3.0/">https://creativecommons.org/licenses/by-sa/3.0/</a><br>
        </div>
        <div>
            Author: Ionicons<br>
            Icon: 211855_locked_icon<br>
            Link: <a href = "https://www.iconfinder.com/iconsets/ionicons">https://www.iconfinder.com/iconsets/ionicons</a><br>
            License:<a href="https://opensource.org/license/MIT">https://opensource.org/license/MIT</a><br>
            Copyright 2024 Ionicons<br>
        </div>
        <div>
            Author: Timothy Miller<br>
            Icon: 134216_menu_lines_hamburger_icon<br>
            Link: <a href="https://www.iconfinder.com/tmthymllr">https://www.iconfinder.com/tmthymllr</a><br>
            License: <a href = "https://creativecommons.org/licenses/by-sa/3.0/">https://creativecommons.org/licenses/by-sa/3.0/</a><br>
        </div>

    </div>

  </template>

<script>

export default {
  name: 'AttributionPage',
};

</script>

  <style scoped>

  .AttributionMain{

    width:100%;
    height:100%;
    display:flex;
    justify-content: space-evenly;
    align-items: center;
    font-size: 1rem;
    color:black;
    flex-direction: column;

  }

  .attrTitle{
    font-size: 2rem;
  }

@media screen and (max-width: 540px ){
    .AttributionMain{
    font-size: 0.8rem;
   }
   .attrTitle{
    font-size: 1.6rem;
  }
}

    </style>
